// The search page's address names its chat (/search?chat_id=), so the page can be reloaded,
// bookmarked or shared: a search started at /search or /search?search_as_member_id= creates its
// chat on the first query, after the page loaded. Replaces the history entry through Turbo's
// session history, and sets its view's lastRenderedLocation (the key its snapshot cache files this
// page under), as Turbo does itself after a same-page visit: Turbo internals, not public API, so a
// Turbo without them gets a plain replaceState. Keeps other query params and the hash;
// search_as_member_id goes, as the chat carries the member. Not during a Turbo preview: a cached
// chat shown while another page loads ("New chat") isn't that page. Used by the provider-chat
// controller.
//
// @param chatUrl [String] the chat's path ("/search?chat_id=42")
// @param win [Window]
export function recordChatUrl(chatUrl, win = window) {
  if (!chatUrl || win.document.documentElement.hasAttribute("data-turbo-preview")) return
  const chat = new URL(chatUrl, win.location.origin)
  const current = new URL(win.location.href)
  if (current.pathname !== chat.pathname || current.searchParams.get("chat_id") === chat.searchParams.get("chat_id")) return

  current.searchParams.delete("search_as_member_id")
  current.searchParams.set("chat_id", chat.searchParams.get("chat_id"))
  const session = win.Turbo?.session
  if (session?.history?.replace) {
    session.history.replace(current, session.history.restorationIdentifier)
    if (session.view) session.view.lastRenderedLocation = current
  } else {
    win.history.replaceState(win.history.state, "", current.pathname + current.search + current.hash)
  }
}
